export default __webpack_public_path__ + "static/media/right-arrow.74b3fb87.svg";